import React from "react";
import { Link } from "react-router-dom";
import CountUp from "react-countup";

import slide from "./../assets/images/main-slider/our_mission_pic.png";

const CounterBlog = [
  { title: "Total Donor", number: "4556" },
  { title: "Volunteer", number: "874" },
  { title: "Total Donation", number: "195234" },
];

const OurMission = () => {
  return (
    <>
      <div className="col-lg-5">
        <div
        // className="dz-media"
        >
          <img src={slide} alt="image" />
        </div>
      </div>
      <div className="col-lg-7 m-b50">
        <div className="section-head">
          {/* <h5 className="sub-title">Our Mission</h5> */}
          <h2>Why "KAF"?</h2>
          <p className="m-t10">
            <strong>Kafin/Kaf (كَافٍ): enough, sufficient</strong>
          </p>
          <p className="m-t20">
            In Arabic, “Kaf” reflects our core aim of providing aspiring
            entrepreneurs with the support and resources they need to succeed,
            making them self-sufficient and independent
          </p>
          {/* <p className="m-t20">
                        <strong>Why 25?</strong> It symbolizes that even something as small as 25 halalas
                        can make a meaningful difference, especially in the early stages of
                        entrepreneurial projects.
                    </p> */}

          <h2>Why 25?</h2>
          <p className="m-t20">
            It symbolizes that even something as small as 25 halalas can make a
            meaningful difference, especially in the early stages of
            entrepreneurial projects
          </p>
        </div>
        {/* <div className="row">
                    {CounterBlog.map((item, index)=>(
                        <div className="col-lg-3 col-sm-4 col-6 m-b30" key={index}>
                            <h2>$
                                <span className="counter">
                                    <CountUp
                                        end={item.number} 
                                        separator = ","
                                        duration= "3"
                                    />
                                </span>
                            </h2>
                            <span className="counter-text">{item.title}</span>
                        </div>
                    ))} 
                </div> */}
        <Link to={"/project"} className="m-r30 m-sm-r10 btn btn-secondary">
          See Projects <i className="flaticon-right-arrows ps-3"></i>
        </Link>
        <Link to={"/how-it-works"} className="btn btn-outline-dark">
          How It Works
        </Link>
      </div>
    </>
  );
};
export default OurMission;
